import { render, staticRenderFns } from "./trade-two-list.page.vue?vue&type=template&id=0766f81a&"
import script from "./trade-two-list.page.vue?vue&type=script&lang=js&"
export * from "./trade-two-list.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0766f81a')) {
      api.createRecord('0766f81a', component.options)
    } else {
      api.reload('0766f81a', component.options)
    }
    module.hot.accept("./trade-two-list.page.vue?vue&type=template&id=0766f81a&", function () {
      api.rerender('0766f81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/tabTrade/trade-two-list.page.vue"
export default component.exports